import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

import { useMultiStyleConfig } from '../../system/hooks';

import { SideBarHOCProps } from './SideBarItem';
import DisplayNames from './enums';

export type SideBarItemRightElementProps = BoxProps;

const SideBarItemRightElement = (props: SideBarItemRightElementProps): React.ReactElement => {
  const { isActive, ...rest } = props as SideBarItemRightElementProps & SideBarHOCProps;

  const { sideBarItemRightElement: themeStyles } = useMultiStyleConfig('SideBar', { ...props, isActive });

  const computedProps: BoxProps = {
    ...(themeStyles as BoxProps),
    ...rest,
    as: 'span'
  };

  return <Box {...computedProps} />;
};

SideBarItemRightElement.propTypes = {};
SideBarItemRightElement.displayName = DisplayNames.SideBarItemRightElement;

export default SideBarItemRightElement;
